import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}')({
  beforeLoad: () => getTitleContextSlice('Ticket Workflows', { hideBreadcrumbs: true }),
  staticData: {
    owner: CodeOwner.Assets,
  },
});
